/**
 * Форматирует строку-адресат для gift_page по полям «кому» / «от кого».
 *
 * - оба: «Артём, вам подарок от Руслана»
 * - только кому: «Артём, вам подарок»
 * - только от кого: «Вам подарок от Руслана»
 */
export function formatGiftDedication(recipient, sender) {
    const to = recipient?.trim() ?? "";
    const from = sender?.trim() ?? "";
    if (to && from)
        return `${to}, вам подарок от ${from}`;
    if (to)
        return `${to}, вам подарок`;
    if (from)
        return `Вам подарок от ${from}`;
    return null;
}
